module.exports = __webpack_public_path__ + "img/bonus3.3d903242.png";